import {
  POPULATE_PROMO_CODES,
  POPULATE_PROMO_CODES_COUNT,
  POPULATE_PROMO_GROUPS,
  POPULATE_PROMO_GROUPS_COUNT,
  POPULATE_PROMO_CODES_BY_GROUP,
  SET_ACTIVE_PROMO_CODE,
  SET_ACTIVE_PROMO_GROUP,
} from "../types";

export default (state, action) => {
  switch (action.type) {
    case POPULATE_PROMO_CODES:
      return {
        ...state,
        promoCodes: action.payload,
      };
    case POPULATE_PROMO_CODES_COUNT:
      return {
        ...state,
        promoCodesCount: action.payload,
      };
    case POPULATE_PROMO_GROUPS:
      return {
        ...state,
        promoGroups: action.payload,
      };
    case POPULATE_PROMO_GROUPS_COUNT:
      return {
        ...state,
        promoGroupsCount: action.payload,
      };
    case POPULATE_PROMO_CODES_BY_GROUP:
      return {
        ...state,
        promoCodesByGroup: action.payload,
      };
    case SET_ACTIVE_PROMO_CODE:
      return {
        ...state,
        activePromoCode: action.payload,
      };
    case SET_ACTIVE_PROMO_GROUP:
      return {
        ...state,
        activePromoGroup: action.payload,
      };
    default:
      return state;
  }
};
